// extracted by mini-css-extract-plugin
module.exports = {"slider-wrapper":"styles_slider-wrapper__MccE9","action-banner-wrapper":"styles_action-banner-wrapper__H7zQm"};